<div class="ts-error new-theme-typography">
    <img src="assets/images/ts-maintenance-graphic.svg"
         alt=""
         class="ts-maintenance-graphic">
    <div class="mat-subtitle-1">Dashboard & reports will be right back!</div>
    <div class="mat-body-2">
        We’re improving things behind the scenes.
        In the meantime, feel free to use our other features.
    </div>
</div>
